import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";
// import Logo from "../images/logo.png";
import ease from "../../../Utility/images/logo.avif";

const Sidebar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const linkStyle = (path: string): React.CSSProperties => ({
    color: location.pathname === path ? "#1780FB" : "inherit",
  });

  return (
    <>
      {/* Header with Toggle + Logo (fixed at top-left with background) */}
      <div className="sidenav-header ">
        <div className="sidenav-toggle" onClick={() => setIsOpen(true)}>
          <span className="bar "></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        <div className="sidenav-logo-top">
          <img src={ease} alt="Logo" />
        </div>
      </div>

      {/* Dark Overlay */}
      {isOpen && (
        <div className="sidenav-overlay" onClick={() => setIsOpen(false)}></div>
      )}

      {/* Sidebar Menu */}
      <div className={`sidenav ${isOpen ? "open" : ""}`}>
        {/* Close Button */}
        <span className="sidenav-close" onClick={() => setIsOpen(false)}>
          &times;
        </span>

        {/* Menu Links */}
        <ul className="sidenav-links">
          <li>
            <Link to="/" onClick={() => setIsOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about-us"
              style={linkStyle("/about-us")}
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/payment-invoice"
              style={linkStyle("/payment-invoice")}
              onClick={() => setIsOpen(false)}
            >
              Free Invoicing
            </Link>
          </li>
          <li>
            <Link
              to="/our-blogs"
              style={linkStyle("/our-blogs")}
              onClick={() => setIsOpen(false)}
            >
              Blogs
            </Link>
          </li>
          <li>
            <button
              className="sidenav-btn -ml-3 mt-2"
              onClick={() => {
                setIsOpen(false);
                navigate("/requestdemo");
              }}
            >
              Request a Demo
            </button>
          </li>
          <li>
            <button
              className="sidenav-btn -ml-3 mt-2"
              onClick={() => {
                setIsOpen(false);
                navigate("/sign-in");
              }}
            >
              Login
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
